export const OCR_ACCESS_ROLE = Object.freeze({
  ADMIN: 'ADMIN',
  AREA_LEADER: 'AREA_LEADER',
  STORE_LEADER: 'STORE_LEADER',
  SALES: 'SALES',
})

export const OCR_ACCESS_ROLES = Object.freeze([
  {
    code: OCR_ACCESS_ROLE.ADMIN,
    nameKey: 'role.admin',
  },
  {
    code: OCR_ACCESS_ROLE.AREA_LEADER,
    nameKey: 'role.areaLeader',
  },
  {
    code: OCR_ACCESS_ROLE.STORE_LEADER,
    nameKey: 'role.storeLeader',
  },
  {
    code: OCR_ACCESS_ROLE.SALES,
    nameKey: 'role.sales',
  },
])